import { SseEventBase } from './sse-event-base.model';
import { SseEventType } from './sse-event-type.model';
import { runInInjectionContext } from '@angular/core';
import { NotificationReasonEnum } from '../../enums/notification/notification-reason.enum';
import { NotificationEventAction } from '../../states/notification-event/notification-event.action';

export class SseNotificationEventByUserEvent extends SseEventBase {
  type: SseEventType = 'notificationEvent';

  onMessage = (event: MessageEvent<any>): void => {
    const resp = JSON.parse(event.data);

      runInInjectionContext(this.injector, () => {
        this.onEvent();
      });
  }

  private onEvent(): void {
    this.ngZone.run(() => {
      this.store.dispatch(new NotificationEventAction.ReloadNotifications(this.data.getUser().id));
    });
  }

}
